import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import useFetchPatientProfileNotesQuery from 'App/hooks/useFetchPatientProfileNotesQuery';
import { MdStickyNote2 } from 'react-icons/md';
import { v4 as uuid } from 'uuid';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styled from '@emotion/styled';

const PopoverStyled = styled(Popover)`
    border-color: var(--brandDanger);

    &.popover {
        &.right {
            .arrow {
                border-right-color: var(--brandDanger);
            }
        }

        &.left {
            .arrow {
                border-left-color: var(--brandDanger);
            }
        }

        &.top {
            .arrow {
                border-top-color: var(--brandDanger);
            }
        }

        &.bottom {
            .arrow {
                border-bottom-color: var(--brandDanger);
            }
        }
    }

    .popover-body {
        color: var(--brandDanger);
    }
`;

const propTypes = {
    patientId: PropTypes.string.isRequired,
};

const defaultProps = {};

const PatientImportantNotesIndicator = ({ patientId }) => {
    const { data } = useFetchPatientProfileNotesQuery(patientId);
    const hasImportantNotes = useMemo(() => {
        return data ? R.any((note) => !!note.important, data) : false;
    }, [data]);

    const popover = (
        <PopoverStyled id={uuid()}>
            <Popover.Content>Review important notes</Popover.Content>
        </PopoverStyled>
    );

    return hasImportantNotes ? (
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" rootClose overlay={popover}>
            <MdStickyNote2 color="#8d1000" aria-label="Important Notes" />
        </OverlayTrigger>
    ) : null;
};

PatientImportantNotesIndicator.propTypes = propTypes;
PatientImportantNotesIndicator.defaultProps = defaultProps;

export default PatientImportantNotesIndicator;
